import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Event } from '@app/modules/calendar/services/calendar-state.service';
import { Reservation } from '@app/shared/interfaces';
import { SegmentEvent, SegmentIoService } from '@app/shared/services/segmentIo/segment-io.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-conflicting-events',
  templateUrl: './dialog-conflicting-events.component.html',
  styleUrls: ['./dialog-conflicting-events.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConflictingEventsComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConflictingEventsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      events: Array<Reservation | Event>;
    },
    private readonly segmentIoService: SegmentIoService
  ) {}

  public ngOnInit() {
    this.segmentIoService.track(SegmentEvent.CalendarConflictingEventsDialogOpened, {
      eventUuids: this.dialogData.events.map((event) => (event as Reservation)?.uuid),
    });
  }

  public openReservation(event: Reservation | Event) {
    this.dialogRef.close(event);
  }
}
